import { hora12 as hora } from './format';   // 12 h en todo el portal («5:00 p. m.»): decisión de Gabriel, 2026-10-06
/**
 * Envío programado del redactor (QA 2026-10-06).
 * - Elegir solo la hora (sin tocar el día) programaba SIEMPRE para mañana, aunque esa hora aún no hubiera llegado hoy.
 * - El botón que abre el selector decía «Programar», igual que el de enviar: no se veía para cuándo quedaba.
 */
const DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

/** Hora elegida sin día → hoy si aún no pasó (con un minuto de margen), si no, mañana. */
export function horaSinDia(hh, mm, ahora = new Date()) {
  const d = new Date(ahora);
  d.setHours(hh || 0, mm || 0, 0, 0);
  if (d.getTime() <= ahora.getTime() + 60_000) d.setDate(d.getDate() + 1);
  return d;
}


/** «hoy 6:40 p. m.» · «mañana 9:00 a. m.» · «ayer …» · «jue 8 oct, 9:00 a. m.». También lo usan Programados y
    Pospuestos (antes «6/10/2026, 18:43:00», en crudo y a 24 h). */
export function textoProgramado(fecha, ahora = new Date()) {
  const dia = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const dif = Math.round((dia(fecha) - dia(ahora)) / 86_400_000);
  if (dif === 0) return `hoy ${hora(fecha)}`;
  if (dif === 1) return `mañana ${hora(fecha)}`;
  if (dif === -1) return `ayer ${hora(fecha)}`;
  return `${DIAS[fecha.getDay()]} ${fecha.getDate()} ${MESES[fecha.getMonth()]}, ${hora(fecha)}`;
}
